export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_57cf32a4-36f0-45b1-b02c-0bf22327c15e/artifacts/p6m4vq7n_UDP%20LOGO.png";

export const WHATSAPP_NUMBER = "971567834333";
export const WHATSAPP_DISPLAY = "+971 56 783 4333";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;
export const EMAIL = "info@udp.ae";
export const COMPANY_NAME = "Universal Dream Properties LLC";
export const COMPANY_LOCATION = "Dubai, United Arab Emirates";
export const LICENSE_NUMBER = "1410017";
export const LAST_UPDATED = "March 2026";

export const GLOBAL_DISCLAIMER =
  "Prices, availability, payment plans, handover dates and project specifications are subject to change and must be confirmed with the relevant developer.";

export const YIELD_DISCLAIMER =
  "Estimated figure based on current market conditions. This is not a guaranteed return. Actual net returns may vary after service charges, maintenance, vacancy periods, property management fees, financing costs and other expenses.";

export const SOCIALS = {
  facebook: {
    url: "https://www.facebook.com/UniversalDreamPropertiesDubai",
    icon: "https://customer-assets.emergentagent.com/job_premium-real-estate-17/artifacts/6u8suugs_s1%20.webp",
    label: "Facebook",
  },
  instagram: {
    url: "https://www.instagram.com/universaldreamproperties",
    icon: null,
    label: "Instagram",
  },
  linkedin: {
    url: "https://www.linkedin.com/in/universal-dream-properties-209161220",
    icon: "https://customer-assets.emergentagent.com/job_premium-real-estate-17/artifacts/3kev0stb_s3.png",
    label: "LinkedIn",
  },
  twitter: {
    url: "https://twitter.com/UNIVERSALDREA18?t=zIz8sAcsWjrMFI9fTsTnvA&s=09",
    icon: "https://customer-assets.emergentagent.com/job_premium-real-estate-17/artifacts/x5kle7sn_s4.webp",
    label: "X / Twitter",
  },
  youtube: {
    url: "https://www.youtube.com/@universaldreamproperties",
    icon: "https://customer-assets.emergentagent.com/job_premium-real-estate-17/artifacts/vn0oo525_s4.png",
    label: "YouTube",
  },
};

export const DEVELOPERS = [
  "EMAAR",
  "DAMAC",
  "SOBHA REALTY",
  "NAKHEEL",
  "MERAAS",
  "AZIZI",
  "BINGHATTI",
  "ELLINGTON",
  "OMNIYAT",
  "SELECT GROUP",
];

export const DEVELOPER_DETAILS = [
  { name: "Emaar Properties", tag: "Master-planner of Downtown Dubai", stat: "AED 30B+ annual revenue", founded: "1997" },
  { name: "DAMAC Properties", tag: "Global luxury developer", stat: "44,000+ homes delivered", founded: "2002" },
  { name: "Sobha Realty", tag: "Backward-integrated craftsmanship", stat: "Waterfront specialist", founded: "1976" },
  { name: "Nakheel", tag: "Creator of the Palm Islands", stat: "Signature Dubai icons", founded: "2000" },
  { name: "Meraas", tag: "Lifestyle destinations & communities", stat: "Bluewaters, City Walk, La Mer", founded: "2007" },
  { name: "Azizi Developments", tag: "Prolific mid-luxury developer", stat: "200+ projects planned/delivered", founded: "2007" },
  { name: "Binghatti", tag: "Signature parametric architecture", stat: "Top-selling off-plan developer 2025", founded: "2008" },
  { name: "Ellington Properties", tag: "Design-led boutique residences", stat: "Award-winning interiors", founded: "2014" },
  { name: "Omniyat", tag: "Ultra-luxury and hospitality-branded", stat: "One Za'abeel, Vela, Orla", founded: "2005" },
  { name: "Select Group", tag: "Marina & waterfront specialist", stat: "Marina Gate, Peninsula", founded: "2002" },
];

export const PROJECTS = [
  {
    id: "sobha-hartland-ii",
    name: "Sobha Hartland II",
    developer: "Sobha Realty",
    tag: "Waterfront Villas",
    location: "Mohammed Bin Rashid City, Dubai",
    yield: "8.2%",
    yieldLabel: "Estimated Gross Rental Yield",
    price: "AED 2.4M+",
    handover: "Q4 2027",
    unitTypes: "3–6 BR Villas & Townhouses",
    paymentPlan: "60/40 · construction-linked",
    constructionStatus: "Off-plan · under construction",
    serviceChargeEstimate: "AED 4 – 6 per sqft / year",
    lastUpdated: "March 2026",
    mapQuery: "Sobha Hartland Dubai",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "emaar-beachfront",
    name: "Emaar Beachfront",
    developer: "Emaar Properties",
    tag: "Private Beach Residences",
    location: "Dubai Harbour",
    yield: "7.8%",
    yieldLabel: "Estimated Gross Rental Yield",
    price: "AED 2.9M+",
    handover: "Q2 2026",
    unitTypes: "1–4 BR Apartments & Penthouses",
    paymentPlan: "80/20 · milestone-based",
    constructionStatus: "Nearing completion",
    serviceChargeEstimate: "AED 22 – 28 per sqft / year",
    lastUpdated: "March 2026",
    mapQuery: "Emaar Beachfront Dubai",
    image: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "damac-lagoons",
    name: "DAMAC Lagoons",
    developer: "DAMAC Properties",
    tag: "Mediterranean Townhouses",
    location: "Dubailand",
    yield: "9.1%",
    yieldLabel: "Estimated Gross Rental Yield",
    price: "AED 1.8M+",
    handover: "Q3 2026",
    unitTypes: "4–6 BR Townhouses & Villas",
    paymentPlan: "65/35 · construction-linked",
    constructionStatus: "Off-plan · under construction",
    serviceChargeEstimate: "AED 3 – 5 per sqft / year",
    lastUpdated: "March 2026",
    mapQuery: "DAMAC Lagoons Dubai",
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "binghatti-skyhall",
    name: "Binghatti Skyhall",
    developer: "Binghatti",
    tag: "Skyline Apartments",
    location: "Business Bay",
    yield: "8.6%",
    yieldLabel: "Estimated Gross Rental Yield",
    price: "AED 1.2M+",
    handover: "Q1 2027",
    unitTypes: "Studio – 3 BR Apartments",
    paymentPlan: "70/30 · construction-linked",
    constructionStatus: "Off-plan · under construction",
    serviceChargeEstimate: "AED 18 – 24 per sqft / year",
    lastUpdated: "March 2026",
    mapQuery: "Business Bay Dubai",
    image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "ellington-the-quayside",
    name: "Ellington The Quayside",
    developer: "Ellington Properties",
    tag: "Boutique Waterfront",
    location: "Business Bay Canal",
    yield: "7.4%",
    yieldLabel: "Estimated Gross Rental Yield",
    price: "AED 2.1M+",
    handover: "Q4 2026",
    unitTypes: "1–3 BR Apartments",
    paymentPlan: "60/40 · milestone-based",
    constructionStatus: "Off-plan · under construction",
    serviceChargeEstimate: "AED 20 – 26 per sqft / year",
    lastUpdated: "March 2026",
    mapQuery: "Business Bay Canal Dubai",
    image: "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "omniyat-vela",
    name: "Omniyat Vela",
    developer: "Omniyat",
    tag: "Ultra-Luxury Penthouses",
    location: "Marasi Bay, Business Bay",
    yield: "6.9%",
    yieldLabel: "Estimated Gross Rental Yield",
    price: "AED 12M+",
    handover: "Q2 2028",
    unitTypes: "Half-floor & full-floor penthouses",
    paymentPlan: "50/50 · construction-linked",
    constructionStatus: "Off-plan · pre-launch",
    serviceChargeEstimate: "AED 45 – 65 per sqft / year",
    lastUpdated: "March 2026",
    mapQuery: "Marasi Bay Dubai",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80",
  },
];

export const WHY_DUBAI = [
  { title: "0% Income Tax", description: "No personal income, capital gains or property tax for individual investors.", stat: "0%", statLabel: "Personal Tax" },
  { title: "Golden Visa Eligibility", description: "Invest AED 2M+ in property and qualify for a 10-year renewable UAE residency.", stat: "10", statLabel: "Year Visa" },
  { title: "Premium Rental Yields", description: "Dubai consistently delivers among the highest gross rental yields of any global property capital.", stat: "8%+", statLabel: "Estimated Yield" },
  { title: "Safest Global City", description: "Ranked among the world's safest cities with world-class healthcare, infrastructure and education.", stat: "#1", statLabel: "MENA Safety" },
];
